module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-mobile-0.289e2099.png";